import { createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { rootReducer } from './reducers';

//Create store and connect the devtools extension
export const store = createStore(rootReducer, {}, composeWithDevTools());
